import { ChangeDetectionStrategy, Component, ViewEncapsulation, signal, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class App implements OnInit {
  protected readonly title = signal('food-service-app');

  ngOnInit(): void {
    if (environment.production) {
      console.warn('PRODUCTION MODE')
    } else {
      console.warn('DEVELOPMENT MODE')
    }
  }
}
